import { defineMessages } from "react-intl";

export const messages = defineMessages({
  noMessages: {
    id: "chat.noMessages",
    defaultMessage: "The messages you write are visible to all participants.",
    description: "Text to be shown when no chat messages",
  },
});
